import React, { Component } from 'react'
import { connect } from 'react-redux';
import { message, Layout } from 'antd';
import TopNav from '../../components/topnav/topnav';
import ForgotpasswordForm from '../../components/forgotpassword/forgotpasswordform';
import {bindActionCreators} from "redux"
import {sendPassResetEmail} from "../../../../core/actions/auth"
import Footer from '../../components/footer/footer';
const { Content } = Layout;

class ForgotPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      toggleAction: false
    };
  }
  componentWillReceiveProps(nextProps) {
    const {resetPasswordError,resetPasswordSuccess} = nextProps
    if(resetPasswordSuccess) {
      message.success("A password reset link has been sent to your email address")
    }
    if(resetPasswordError) message.error(resetPasswordError)
  }
  toggleModal = () => this.setState({
    toggleAction: !this.state.toggleAction
  })

  render() {
    const { toggleAction } = this.state
    return (
      <div className="">
        <TopNav history={this.props.history} toggleAction={toggleAction} toggleModal={this.toggleModal}/>
        <Content className="forgot-password">
          <ForgotpasswordForm 
          loading={this.props.loading}
          resetPasswordError={this.props.resetPasswordError}
          resetPasswordSuccess={this.props.resetPasswordSuccess}
          resetPassword={this.props.resetPassword}
          sendPassResetEmail={this.props.sendPassResetEmail}
          toggleModal={this.toggleModal}/>
        </Content>
        <Footer />
      </div>
    )
  } 
}

const mapStateToProps = state => ({
  loading: state.auth.loading,
  resetPasswordSuccess:state.auth.resetPasswordSuccess,
  resetPasswordError: state.auth.resetPasswordError
});


const mapDispatchToProps = dispatch => bindActionCreators({
  sendPassResetEmail,
},dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ForgotPassword);

